/* tslint:disable */

/**
 */
export class Point {
    X_POSITION?: number;
    Y_POINT?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/point.ts